<template>
    <div>
      <div class="cstm_underlinedtab_ul_holder">
        <!-- tabs -->
        <ul class="cstm_underlinedtab_ul horizontal_scrollbar">
            <li  v-for="(user, index) in users" :key="index"
            @click="getUserDetails(index)"
                :class="[info==index ? 'active' : '']"
                class="cursor-pointer"
            >
                <img v-if="user.child.picture" :src="user.child.picture" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block">
                <img v-else
                alt="user-img" width="40" height="40"
                class="rounded-full shadow-md cursor-pointer block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
                <h4 style="max-width: 150px;" class="one_line_truncate pl-4">{{user.child.first_name}} {{user.child.last_name}}</h4>
            </li>
        </ul>
        <vs-button @click="addpopup=true"> Add User</vs-button>
      </div>

        
        <vs-row>
            <vs-col vs-w="12" class="p-2">
                <UserInfo />
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <vs-card class="content_mb_0 mb-0 h-full">
                    <div class="flex flex-wrap justify-between items-center mb-4">
                        <h4>Personal Bio</h4>
                    </div>
                    <div>
                        <vs-tabs class="one_line_tab_label">
                            <vs-tab label="Personal Bio">
                                <PersonalBio :clientDetails="clientDetails" />
                            </vs-tab>
                            <vs-tab label="Education">
                                <Education  @setAfterUpdate="setAfterUpdate" :educationProps="clientDetails.education" :clientDetails="clientDetails" />
                            </vs-tab>
                            <vs-tab label="Language">
                              <Language @setAfterUpdate="getUserAllDetails" :languageProps="clientDetails.language" :clientDetails="clientDetails" />
                            </vs-tab>
                            <vs-tab label="Award">
                              <Award @setAfterUpdate="getUserAllDetails"  :awardProps="clientDetails.award" :clientDetails="clientDetails" />
                            </vs-tab>
                            <vs-tab label="Additional Information">
                                <AdditionalInfoComponent  :clientDetails="clientDetails" :user_id="user_id" />
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </vs-card>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <vs-card class="content_mb_0 mb-0 h-full contact_info_card">
                    <div class="flex flex-wrap justify-between items-center mb-4">
                        <h4>Contact Information</h4>
                    </div>
                    <div>
                        <vs-tabs>
                            <vs-tab label="Email">
                                <Email :email="email" />
                            </vs-tab>
                            <vs-tab label="Phone">
                                <Phone :checkEditPermission="checkEditPermission" :clientDetails="clientDetails"
                                    @userUpdated="userUpdated"
                                    />
                            </vs-tab>
                            <vs-tab label="Address">
                                <Address  :checkEditPermission="checkEditPermission" :clientDetails="clientDetails"  @userUpdated="userUpdated" />
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </vs-card>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <vs-card class="content_mb_0 mb-0">
                    <Timeline :student_id="user_id"
                    :new_activity="new_activity" />
                </vs-card>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <vs-card class="content_mb_0 mb-0">
                    <div slot="header" class="flex flex-wrap justify-between items-center">
                        <h4>Permissions</h4>
                        <vs-tooltip text="View All" color="primary">
                          <vs-button type="border" color="primary" icon-pack="feather" icon="icon-eye" />
                        </vs-tooltip>
                    </div>
                    <div>
                        <h6 class="mb-2">Schedule</h6>
                        <div style="height: 175px; overflow-y: auto;" class="vertical_scrollbar">
                            <div class="user_schedule_holder" v-for="(eachScheduleData, index) in schedules" :key="index">
                                {{ eachScheduleData.title }}
                                <vs-checkbox v-model="eachScheduleData.active" />
                            </div>
                        </div>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>

        <vs-popup
      classContent="popup-example"
      title="Add User"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add" v-if="addpopup">
        <vs-row>
        
          <vs-checkbox
            v-model="sameasparentAddress"
            @change="abc"
            class="custom_Input"
            value="same"
            style="width: 100%"
            >Same as Parent's Address</vs-checkbox
          >

          <vs-col
            :vs-xs="12"
            :vs-md="12"
            :vs-lg="12"
            class="p-2"
            v-for="childfield in staticChildFields"
            :key="childfield.id"
          >
         
           <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id' && childfield.field_name != 'platform_timezone_id' && childfield.field_name !=='dob'" 
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            
            />
            <flat-pickr
                v-else-if="childfield.field_name ==='dob'"
                v-model="minor[childfield.field_name]"
                class="w-full"
                :config="{maxDate: new Date()}"
                :name="childfield.field_name"
                :data-vv-name="childfield.field_label"
                v-validate="childfield.enabled_child == true ? 'required' : ''"
              ></flat-pickr>
            
             <v-select
                  v-else-if="childfield.field_name != 'platform_customer_countries_id' && childfield.field_name == 'platform_timezone_id'"
                  v-model="minor[childfield.field_name]"
                  v-validate="childfield.enabled_child == true ? 'required' : ''"
                  :reduce="(option) => option.timezone_id"
                  label="location"
                  :name="childfield.field_label"
                  :options="platformTimeZone"
                  style="width: 100%"

               icon-pack="feather"
              icon="icon-edit"
              icon-after
                />
            <v-select
              v-else
              v-model="minor[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
             
              :reduce="(option) => option.id"
              label="country_name"
              :name="childfield.field_label"
              :options="countryList"
              style="width: 100%"
            />
            <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="childfield.field_label=='Phone'">
                <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
             </div>
            <span
              v-show="errors.has(`add.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`add.${childfield.field_label}`) }}</span
            >
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { GeneralMixins } from '@/mixins/generalMixins/GeneralMixins.js'
import { GetCountryList } from '@/api/common'

import vSelect from 'vue-select'
import { ClientDetails, createMinor } from '@/api/client'
import Email from '@/views/pages/v1/StudentProfile/components/contact_information/email.vue'
import Phone from '@/views/pages/v1/StudentProfile/components/contact_information/phone.vue'
import Address from '@/views/pages/v1/StudentProfile/components/contact_information/address.vue'
import Timeline from '@/views/pages/v1/StudentProfile/components/account/timeline.vue'
import AdditionalInfoComponent from '@/views/pages/v1/StudentProfile/components/personal_bio/additional_info'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { fetchCustomStaticFields } from '@/api/customfield'

import UserInfo from '../account/user_info.vue'
import PersonalBio from '../profile/personal_bio.vue'
import Education from '../personal_bio/education.vue'
import Language from '@/views/pages/v1/StudentProfile/components/personal_bio/language.vue'
import Award from '@/views/pages/v1/StudentProfile/components/personal_bio/award.vue'
// import AdditionalInformation from '../additional_info.vue'

export default {
  data () {
    return {
      table_name:'student_list',
      sameasparentAddress: false,
      minor: {
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        state: null,
        zip: null,
        city: null,
        platform_customer_countries_id: null
      },
      staticChildFields:[],
      addpopup: false,
      info:0,
      showMore: true,
      email:'',
      phone:null,
      address:null,
      new_activity:null,
      clientDetails:null,
      user_id:null,
      schedules: [
        {
          id: 1,
          title: 'Student Course Schedule View',
          active: true
        },
        {
          id: 2,
          title: 'Teacher Course Schedule View',
          active: true
        },
        {
          id: 3,
          title: 'Room view',
          active: true
        },
        {
          id: 4,
          title: 'Cancel Schedule',
          active: true
        },
        {
          id: 5,
          title: 'Reschedule Session',
          active: true
        }
      ]
    }
  },
  mixins: [PermissionMiddleware, GeneralMixins],
  mounted () {
    this.fetch_field_list()
    this.user_id = this.users[this.info].child.id ? this.users[this.info].child.id : this.users[this.info].child.client_users_id
    this.getUserAllDetails()
    this.fetchPLatformTimeZone()
    this.fetchCountry()
    

  },
  props:{
    users:{
      default:null
    },
    parentDetails:{
      default:null
    }
  },
  components: {
    vSelect,
    UserInfo,
    PersonalBio,
    Education,
    Language,
    Award,
    AdditionalInfoComponent,
    Email,
    Phone,
    Address,
    Timeline,
    flatPickr
  },
  watch: {

  },
  methods: {
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {}
    },
    async handleSave () {
      try {
        const result = this.$validator.validateAll('add')
        if (result) {
          const data = await createMinor(
            this.minor,
            this.$route.params.client_id,
            this.$store.getters.customerId
          )
          this.addpopup = false
          this.showSuccessMessage(
            'success',
            'User Added Successfully',
            'success'
          )
          this.$emit('userUpdated', true)
          const newClient = data.data.data.clientUser
          const child = newClient.basic_details
          child.client_user_address = newClient.basic_details.address
          child.active_user = '1'
          child.client_user_address.client_users_id =
                newClient.basic_details.client_users_id
          const __temp = {
            address: newClient.basic_details.address,
            child
          }
         
          this.minor = {
            first_name: null,
            middle_name: null,
            last_name: null,
            email: null,
            mobile: null,
            address1: null,
            address2: null,
            state: null,
            city: null,
            zip: null,
            platform_customer_countries_id: null,
            platform_timezone_id:''
          }
         
          this.getUserAllDetails()
             
        }
           
      } catch (api_error) {
        this.showSuccessMessage('Error', api_error.data.message, 'danger')
     
      }
    },
    handleAddCancel () {
      this.addpopup = false
      this.minor = {
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        state: null,
        city: null,
        zip: null,
        platform_customer_countries_id: null
      }
    },
    abc () {
      if (this.sameasparentAddress === true) {
        this.minor.address1 = this.parentDetails.address.address1
        this.minor.address2 = this.parentDetails.address.address2
        this.minor.state = this.parentDetails.address.state
        this.minor.zip = this.parentDetails.address.zip
        this.minor.city = this.parentDetails.address.city
        this.minor.platform_customer_countries_id =
          this.parentDetails.address.platform_customer_countries_id
      }
    },
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(4, customerId, {table_name:this.table_name})
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) {}
    },
    async userUpdated () {
      this.$emit('userUpdated', true)
    },
    async getUserAllDetails () {
      try {
        const { data } = await ClientDetails(
          this.user_id,
          this.$store.getters.customerId
        )
        this.clientDetails = data.data.clientUser
        this.email = this.clientDetails.basic_details.email
      } catch (e) {
        //
      } 
    },
    async getUserDetails (index) {
      this.info = index
      this.user_id = this.users[this.info].child.id ? this.users[this.info].child.id : this.users[this.info].child.client_users_id
      this.getUserAllDetails()
    }
  }
}
</script>
